<template>
  <div :class="[color, 'custom-label-normal']">
    <slot></slot>
    <span v-if="requiredMark" class="custom-required">
      <span class="">必須</span>
    </span>
    <span v-if="optionalMark" class="custom-optional">
      <span class="">任意</span>
    </span>
  </div>
</template>

<script>
export default {
  name: "FieldLabelNormal",
  props: {
    requiredMark: {
      default: false,
      type: Boolean
    },
    optionalMark: {
      default: false,
      type: Boolean
    },
    color: {
      default: "primary_label--text",
      type: String
    }
  }
};
</script>

<style lang="scss" scoped>
.custom-label-normal {
  font-size: $size-label;
  color: $color-label;
  margin-bottom: 5px;
  margin-top: 5px;
}

.custom-required {
  background-color: $red;
  color: $white;
  padding: 0 1em;
  align-items: center;
  border-radius: 4px;
  display: inline-flex;
  font-size: $size-label-tip;
  height: 2em;
  line-height: 1.5;
  margin: 0 16px 8px 16px;
}

.custom-optional {
  background-color: $light-grey;
  color: $white;
  padding: 0 1em;
  align-items: center;
  border-radius: 4px;
  display: inline-flex;
  font-size: $size-label-tip;
  height: 2em;
  line-height: 1.5;
  margin: 0 10px;
}

//共通label font size
@media screen and (max-width: $size-mobile) {
  .custom-label-normal {
    font-size: $size-normal !important;
  }
}
</style>
